module.exports = __webpack_public_path__ + "resources/img/loading.gif";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/loading.gif
// module id = 1232
// module chunks = 0